@if (rates && rates.length) {

    @for (rate of rates; track rate) {
  
        @if (rate.relationship === 'Step Up/Down') {
/
} @else {

            {{ rate.relationship | lowercase }}
        
}
                @if (rate.benchmark !== '') {

            {{ rate.benchmark }} +
        
}
        @if (rate.cash_and_pik == 'And' ) {

            <ng-container *ngTemplateOutlet="interest_rates_exact_or_range; context: {prefix: '', suffix: 'Cash', exact: rate.cash_exact_percentage, min: rate.cash_min_percentage, max: rate.cash_max_percentage}"></ng-container>
            <ng-container *ngTemplateOutlet="interest_rates_exact_or_range; context: {prefix: '&', suffix: 'PIK', exact: rate.pik_exact_percentage, min: rate.pik_min_percentage, max: rate.pik_max_percentage}"></ng-container>
        
} @else {

            @if (rates.length > 1) {

                <ng-container *ngTemplateOutlet="interest_rates_exact_or_range; context: {prefix: '', suffix: 'Cash', exact: rate.cash_exact_percentage, min: rate.cash_min_percentage, max: rate.cash_max_percentage}"></ng-container>
                <ng-container *ngTemplateOutlet="interest_rates_exact_or_range; context: {prefix: '', suffix: 'PIK', exact: rate.pik_exact_percentage, min: rate.pik_min_percentage, max: rate.pik_max_percentage}"></ng-container>
            
} @else {

                <ng-container *ngTemplateOutlet="interest_rates_exact_or_range; context: {prefix: '', suffix: '', exact: rate.cash_exact_percentage, min: rate.cash_min_percentage, max: rate.cash_max_percentage}"></ng-container>
                <ng-container *ngTemplateOutlet="interest_rates_exact_or_range; context: {prefix: '', suffix: 'PIK', exact: rate.pik_exact_percentage, min: rate.pik_min_percentage, max: rate.pik_max_percentage}"></ng-container>
            
}
                    
}
                @if (rate.default_incremental_percentage > 0) {

            (Default Rate: + {{ rate.default_incremental_percentage }}%)
        
}
    
}

}

<ng-template #interest_rates_exact_or_range let-exact="exact" let-min="min" let-max="max" let-prefix="prefix" let-suffix="suffix">

    @if (parseFloat(min) > 0 && parseFloat(max) > 0) {

        {{prefix}} {{ min }} - {{ max }}% {{suffix}}
    
} @else {

        @if (exact > 0 || exact === '0') {

            {{prefix}} {{ exact }}% {{suffix}}
        
}
    
}
    </ng-template>
